import { render } from "./MessageBody.vue?vue&type=template&id=78716018&scoped=true"
import script from "./MessageBody.vue?vue&type=script&lang=js"
export * from "./MessageBody.vue?vue&type=script&lang=js"

import "./MessageBody.vue?vue&type=style&index=0&id=78716018&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78716018"]])

export default __exports__